import config from '../config';
import { request } from '../utils/request';

const itSelfDomain = `${config.host}${config.apiRouter.itSelf}`;

const api = {
  // it资源申请相关接口
  serverApply: {
    // 获取各种枚举值
    getOptions (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetOptions`,
        data,
      });
    },
    // 查询云平台资源申请表列表
    getApplyResourceList (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplyResourceList`,
        data,
      });
    },
    // 提交云平台资源申请表
    submitApplyResource (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitApplyResource`,
        data,
      });
    },
    // 查询IT资源申请实施结果列表
    getApplyResourceResultList (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplyResourceResultList`,
        data,
      });
    },
    // 查询云平台资源申请表
    getApplyResource (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplyResource`,
        data,
      });
    },
    // 提交IT资源申请实施结果
    submitApplyResourceResult (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitApplyResourceResult`,
        data,
      });
    },
    // 更新云平台资源申请表状态
    updateApplyResourceState (data) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/UpdateApplyResourceState`,
        data,
      });
    },

    // 下载云平台资源申请表文件
    downloadApplyResource (id) {
      window.open(
        `${itSelfDomain}/DownloadApplyResource?apply_resource_id=${id}`,
        '_blank');
    },
    // 下载模板
    downloadApplyResourceResultTemplate () {
      window.open(
        `${itSelfDomain}/DownloadApplyResourceResultTemplate`,
        '_blank');
    },
    // 获取导入url
    getUploadUrl () {
      return `${itSelfDomain}/ImportApplyResourceResult`;
    },
  },
  // VPN申请相关接口
  vpnApply: {
    // 查询远程接入系统业务申请变更表列表
    getApplyVpnList (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplyVpnList`,
        data,
      });
    },
    // 查询远程接入系统业务申请变更表
    getApplyVpn (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplyVpn`,
        data,
      });
    },
    // 提交远程接入系统业务申请变更表
    submitApplyVpn (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitApplyVpn`,
        data,
      });
    },
    // 更新远程接入系统业务申请变更表状态
    updateApplyVpnState (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/UpdateApplyVpnState`,
        data,
      });
    },
    // 下载远程接入系统业务申请变更表文件
    downloadApplyVpn (id) {
      window.open(
        `${itSelfDomain}/DownloadApplyVpn?apply_id=${id}`,
        '_blank');
    },
  },
  // 堡垒机（运维审计）申请相关接口
  bastionApply: {
    // 查询远程接入系统业务申请变更表列表
    getApplySrvPermissionList (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplySrvPermissionList`,
        data,
      });
    },
    // 查询运维审计系统业务申请变更表
    getApplySrvPermission (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetApplySrvPermission`,
        data,
      });
    },
    // 提交运维审计系统业务申请变更表
    submitApplySrvPermission (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitApplySrvPermission`,
        data,
      });
    },
    // 更新运维审计系统业务申请变更表状态
    updateApplySrvPermissionState (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/UpdateApplySrvPermissionState`,
        data,
      });
    },
    // 下载运维审计系统业务申请变更表文件
    downloadApplySrvPermission (id) {
      window.open(
        `${itSelfDomain}/DownloadApplySrvPermission?apply_id=${id}`,
        '_blank');
    },
  },
  // 业务变更申请(业务端口、obs对象存储、负载均衡)相关接口
  bisAlterApply: {
    // 查询业务变更申请表列表
    getBizAlterApplyList (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetBizAlterApplyList`,
        data,
      });
    },
    // 查询业务变更申请表
    getBizAlterApply (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetBizAlterApply`,
        data,
      });
    },
    // 查询业务变更申请实施结果列表
    getBizAlterApplyResultList (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/GetBizAlterApplyResultList`,
        data,
      });
    },
    // 提交业务变更申请实施结果
    submitBizAlterApplyResult (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitBizAlterApplyResult`,
        data,
      });
    },
    // 提交业务变更申请表
    submitBizAlterApply (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/SubmitBizAlterApply`,
        data,
      });
    },
    // 更新业务变更申请表状态
    updateBizAlterApplyState (data = {}) {
      return request({
        method: 'POST',
        url: `${itSelfDomain}/UpdateBizAlterApplyState`,
        data,
      });
    },
    // 下载业务变更申请表文件
    downloadBizAlterApply (id) {
      window.open(
        `${itSelfDomain}/DownloadBizAlterApply?apply_id=${id}`,
        '_blank');
    },
    // 下载模板
    downloadTemplate (formType) {
      window.open(
        `${itSelfDomain}/DownloadBizAlterApplyResultTemplate?form_type=${formType}`,
        '_blank');
    },
    // 获取导入url
    getUploadUrl () {
      return `${itSelfDomain}/ImportBizAlterApplyResult`;
    },
  },
};
export default api;
